import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { DateService } from "@src/services";
import { normalize } from "@src/utils";

export const useWeeks = () => {
  const i18n = useI18n();

  const weeks = computed(() => {
    const items = [0, 1, 2, 3, 4].map((index) => ({
      id: `week_${index}`,
      title: DateService.formatWeekRange(index, i18n.locale.value),
      subtitle: index === 0 ? i18n.t("Текущая неделя") : undefined,
    }));

    return normalize(items, "id");
  });

  return weeks;
};
